/* @flow */

import formatarReal from './formatar-real';
import { MOEDA } from './constants';

const formatarRealComMoeda = (numero: number | string) => `${MOEDA} ${formatarReal(numero)}`;

export default formatarRealComMoeda;
